module.exports = __webpack_public_path__ + "img/ass13.b94af781.png";